module.exports = __webpack_public_path__ + "img/top.420cd9fa.png";